module.exports = function(n){
	return n[0] === '_' && n.length > 1;
}
